import { render, staticRenderFns } from "./mobile-app.vue?vue&type=template&id=78c8e4b1&"
import script from "./mobile-app.vue?vue&type=script&lang=js&"
export * from "./mobile-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports